module.exports = __webpack_public_path__ + "static/media/PSEImage.04894cc4.png";